import React, { Component } from 'react'

import { Layout, Login } from '../../components'
import { Container, Row, Col } from 'reactstrap';
import { Register } from '..';
import HisLogo from '../../assets/images/his-hotels.png';
import '../../assets/css/custom2.css'

export default class Auth extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
                <section>
                    <Container className='rcontainer'>          
                        <Row className='rwapper'>
                            <Col md={12}>
                                <Login />
                            </Col>
                        </Row>
                        <div style={{position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', textAlign: 'center'}}>
                            <p style={{fontSize: '14px', marginBottom: '30px'}}>Copyright HIS Hotels 2024. All rights reserved</p>
                        </div>
                    </Container>
                </section>
        )
    }
}